// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '8631bd8d5898664ebd909ab631fcb923b61ed956',
  short: '8631bd8',
  builtAt: '2026-11-04T17:27:23.383Z',
} as const;
